import React, { useEffect } from 'react';
import WebsiteCategory from './WebsiteCategory';
import WebsiteKeyword from './WebsiteKeyword';
import WebsiteSearchResults from './WebsiteSearchResults';
import { colors } from '../../../config/constants';
import { useDispatch, useSelector } from 'react-redux';
import { StateProps } from '../../../redux/reducer';
import { updateReviewTab, update_breadcrumb } from '../../../redux/action';
import { useParams } from 'react-router-dom';
import PageHeading from '../../../components/PageHeading/PageHeading';

// type WebisiteReviewProps = {
//   siteOrganizationId?: string | undefined;
//   siteOrganizationIndexId?: string | undefined;
// };

const WebisiteReview = () => {
  const { siteOrganizationIndexId, siteOrganizationId } = useParams();
  const dispatch = useDispatch();
  const reviewTab = useSelector((state: StateProps) => state.reviewTab);

  useEffect(() => {
    const breadcrumb = [
      { path: '/websiteAdmin', name: 'Website' },
      { path: `/websiteDetail/${siteOrganizationId}`, name: 'Website Details' },
      {
        path: `/websiteReview/${siteOrganizationIndexId}/${siteOrganizationId}`,
        name: 'Review',
      },
    ];
    dispatch(update_breadcrumb(breadcrumb));
  }, []);

  useEffect(() => {
    dispatch(
      updateReviewTab({
        ...reviewTab,
        siteOrgIndexID: siteOrganizationIndexId,
      })
    );
    return () => {
      dispatch(
        updateReviewTab({
          ...reviewTab,
          tabName: 'category',
          siteOrgIndexID: siteOrganizationIndexId,
          categoryID: '',
          keywordID: '',
        })
      );
    };
  }, []);

  return (
    <div className="mx-2">
      <PageHeading label="Website Review" />
      <div className="bg-white rounded-sm ">
        <div className="w-full flex justify-center items-center p-1 pt-4">
          <div className="flex items-center justify-between p-1 z-20 w-full rounded-sm">
            <div
              className="flex flex-col items-center justify-center cursor-pointer"
              onClick={() =>
                dispatch(
                  updateReviewTab({
                    ...reviewTab,
                    tabName: 'category',
                    siteOrgIndexID: siteOrganizationIndexId,
                    categoryID: '',
                    keywordID: '',
                  })
                )
              }
            >
              <div
                className={`flex items-center justify-center h-[40px] w-[40px] rounded-full text-[20px] text-white ${
                  reviewTab.tabName === 'category' ||
                  reviewTab.tabName === 'keyword' ||
                  reviewTab.tabName === 'searchResult'
                    ? `${colors.primary}`
                    : 'bg-[#cccbcb]'
                }`}
              >
                <i className={`fa-solid fa-layer-group`}></i>
              </div>
              <div className="text-[#191950] text-sm mt-1"> Category</div>
            </div>
            <div
              className={`h-[2px] mb-[21px] ${
                reviewTab.tabName === 'keyword' ||
                reviewTab.tabName === 'searchResult'
                  ? `${colors.primary}`
                  : 'bg-[#cccbcb]'
              } w-full rounded-full`}
            ></div>
            <div
              className={`flex flex-col items-center justify-center ${
                reviewTab.tabName === 'searchResult' && 'cursor-pointer'
              }`}
              onClick={() => {
                if (reviewTab.tabName === 'searchResult') {
                  dispatch(
                    updateReviewTab({
                      ...reviewTab,
                      tabName: 'keyword',
                      siteOrgIndexID: siteOrganizationIndexId,
                    })
                  );
                }
              }}
            >
              <div
                className={`flex items-center justify-center h-[40px] w-[40px] rounded-full text-[20px] text-white  ${
                  reviewTab.tabName === 'keyword' ||
                  reviewTab.tabName === 'searchResult'
                    ? `${colors.primary}`
                    : 'bg-[#cccbcb]'
                }`}
              >
                {' '}
                <i className={`fa-solid fa-key`}></i>
              </div>
              <div
                className={`${
                  reviewTab.tabName === 'keyword' ||
                  reviewTab.tabName === 'searchResult'
                    ? 'text-[#191950] '
                    : 'text-[#cccbcb]`'
                } text-sm mt-1`}
              >
                {' '}
                Keyword
              </div>
            </div>
            <div
              className={`h-[2px] mb-[21px] ${
                reviewTab.tabName === 'searchResult'
                  ? `${colors.primary}`
                  : 'bg-[#cccbcb]'
              } w-full rounded-full`}
            ></div>
            <div className="flex flex-col items-center justify-center">
              <div
                className={`flex items-center justify-center h-[40px] w-[40px] rounded-full text-[20px] text-white  ${
                  reviewTab.tabName === 'searchResult'
                    ? `${colors.primary}`
                    : 'bg-[#cccbcb]'
                }`}
              >
                {' '}
                <i className="fa-solid fa-magnifying-glass"></i>
              </div>
              <div
                className={`${
                  reviewTab.tabName === 'searchResult'
                    ? 'text-[#191950] '
                    : 'text-[#cccbcb]`'
                } text-sm mt-1`}
              >
                Results
              </div>
            </div>
          </div>
        </div>

        {reviewTab.tabName === 'category' && (
          <WebsiteCategory siteOrgIndexId={siteOrganizationIndexId as string} />
        )}
        {reviewTab.tabName === 'keyword' && <WebsiteKeyword />}
        {reviewTab.tabName === 'searchResult' && <WebsiteSearchResults />}
      </div>
    </div>
  );
};

export default WebisiteReview;
